import { render, staticRenderFns } from "./FootprintTablePrevButton.vue?vue&type=template&id=62b2d467&scoped=true&"
import script from "./FootprintTablePrevButton.vue?vue&type=script&lang=js&"
export * from "./FootprintTablePrevButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b2d467",
  null
  
)

export default component.exports